import { useRef } from "react"
import { Button } from "../common/button"
import { trackEvent, EVENTS, EVENT_IDS } from "~/common/analytics"
import { downloadPath } from "~/common/paths"
import { Link } from "~/ui/link"

const TRACKING_DATA = {
  unique_id: EVENT_IDS.GET_APP_CLICKED,
}

export function GetTheAppMobileButton(): JSX.Element {
  const phoneInputRef = useRef<HTMLInputElement>(null)

  const isPhoneInputEnabled = (): boolean => {
    if (!phoneInputRef.current) return false
    return !window.matchMedia("(max-width: 640px)").matches
  }

  const handleGetAppClick = (): void => {
    if (!isPhoneInputEnabled()) {
      trackEvent(EVENTS.ITEM_PRESSED, {
        ...TRACKING_DATA,
        success: true,
      })
      window.location.href = downloadPath({})
    }
  }

  return (
    <div className="mx-auto mt-8 w-full max-w-60 md:mx-0 md:mb-8 md:mt-12 md:hidden md:self-start">
      <Link
        to={!isPhoneInputEnabled() ? downloadPath({}) : "#"}
        onClick={(e): void => {
          e.preventDefault()
          handleGetAppClick()
        }}
      >
        <Button>GET THE APP</Button>
      </Link>
    </div>
  )
}
